$(function(){
  function sideForm(){
    $('.side-form').toggleClass('side-form_opened');
    $('.side-form__btn-content_close, .side-form__btn-content_open').toggleClass('side-form__btn-content_hide');
    $('.side-form__overlay').toggleClass('side-form__overlay_revealed');
  }

  $('.side-form__btn, .side-form__overlay').click(sideForm);

  $('body').keyup(function(e){
    if ($('.side-form_opened').length && e.which == 27){
      sideForm();
    }
  });

  $('#simply-form').validator().on('submit', function (e) {
    if (e.isDefaultPrevented()) {
      return false;
    } else {
      e.preventDefault();

      var $btn = $('#db_send');
      var $form = $('#simply-form');

      $btn.removeClass("banner-form-hidden-spinner").prop('disabled', true);

      $.ajax({
        type: "POST",
        url: $form.attr('action'),
        data: $form.serialize(),
        dataType: 'html',
        success: function(response){
          $form.find('.msg-success').removeClass('hidden');

          $form.find('input[type="text"], input[type="email"], input[type="tel"], textarea').val("");
          $form.find('input[type="checkbox"]').prop('checked', false);

          setTimeout(function() {
            $form.find('.msg-success').addClass('hidden');
          }, 3000);
        },
        error: function(xhr, status, error) {
          console.error("Error:", error);
          alert("Error submitting form.");
        },
        complete: function() {
          $btn.addClass("banner-form-hidden-spinner").prop('disabled', false);
        }
      });

      return false;
    }
  });
});